/**
 * @description 
 */
import {
  getCheatInfo,
  checkLoginName,
  getLoginVersion,
  checkcode,
  checkcodeByLoginName,
  logout
} from '@/api/courseApi'
import config from '@/config'
import cookies from '@/utils/cookie'
import store from "@/store";

function clearAllCookie () {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g)

  var exdate = new Date()
  exdate.setDate(exdate.getDate() - 1)

  if (keys) {
    for (var i = keys.length; i--;) {
      if (keys[i].toLowerCase().indexOf('guide') != -1) {
        continue
      }
      document.cookie = keys[i] + '=; expires=' + exdate.toGMTString() + ';'
      document.cookie = keys[i] + '=; expires=' + exdate.toGMTString() + '; path=/;'
      document.cookie = keys[i] + '=; expires=' + exdate.toGMTString() + '; path=/; domain=' + config.UMOOC_COOKIE_DOMAIN + ';'
    }
  }
}
export default class User {
  constructor(params) {
    params = params || {}
    let { loginName = '', name = '', sex = 1, orgId, roleId, headimage, orgLogo, orgName = '', orgHome = '', userId, authorization = '', role , avatar = '', userID, token = '' } = params
    this.loginName = loginName
    this.name = name
    this.sex = sex
    this.orgId = orgId || -1
    this.role = roleId || role || 9
    this.avatar = headimage || avatar
    this.userId = userId || userID || ''
    this.token = authorization || token
    this.password = ''
    this.cellphone = ''  //手机号
    this.code = '' // 验证码
    this.orgLogo = orgLogo
    this.orgName = orgName
    this.orgHome = orgHome
  }

  getCheatInfo (type) {
    if (type == 'org') {
      return getCheatInfo({
        organId: this.orgId,
        loginName: this.loginName
      })
    }
    return getCheatInfo({
      loginName: this.loginName
    })
  }

  checkLoginName (type) {
    if (type == 'org') {
      return checkLoginName({
        organId: this.orgId,
        loginName: this.loginName,
        password: this.password
      })
    }
    return checkLoginName({
      loginName: this.loginName,
      password: this.password
    })
  }

  getLoginVersion () {
    return getLoginVersion({
      loginName: this.loginName
    })
  }

  loginV1 () {
    let form = document.createElement('form')
    form.action = config.UMOOC_SERVER_HOST + '/umooc/user/login.do'
    form.method = 'post'
    let loginName = document.createElement("input")
    loginName.type = 'hidden'
    loginName.name = 'name'
    loginName.value = this.loginName
    let password = document.createElement("input")
    password.type = 'hidden'
    password.name = 'passwd'
    password.value = this.password
    form.appendChild(loginName)
    form.appendChild(password)
    document.body.appendChild(form)
    form.submit()
  }

  loginV2 () {
    let form = document.createElement('form')
    form.action = config.COURSE_API_HOST + '/users/login/v2'
    form.method = 'post'
    let loginName = document.createElement("input")
    loginName.type = 'hidden'
    loginName.name = 'loginName'
    loginName.value = this.loginName
    let password = document.createElement("input")
    password.type = 'hidden'
    password.name = 'password'
    password.value = this.password
    if (!store.state.org.org.isMainSite) { //优学院主站点通过cookie方式写入重定向url，二级站点由于有sld目录 写入的cookie path带有sld 后台无法读取重定向到该url,通过参数的方式传到登录后台
      let redirectCookie = cookies.get('loginRedirectUrl')
      if (redirectCookie) {
        let redirect = document.createElement("input")
        redirect.type = 'hidden'
        redirect.name = 'loginRedirectUrl'
        redirect.value = encodeURIComponent(redirectCookie)
        form.appendChild(redirect)
      }
    }
    form.appendChild(loginName)
    form.appendChild(password)
    document.body.appendChild(form)
    form.submit()
  }

  checkcode () {
    return checkcode({
      cellphone: this.cellphone,
      code: this.code
    })
  }

  checkcodeByLoginName () {
    return checkcodeByLoginName({
      loginName: this.loginName,
      securityCode: this.code
    })
  }

  phoneLogin () {
    let form = document.createElement('form')
    form.action = config.COURSE_API_HOST + '/cellphonelogin'
    form.method = 'get'
    let code = document.createElement("input")
    code.type = 'hidden'
    code.name = 'code'
    code.value = this.code
    let cellphone = document.createElement("input")
    cellphone.type = 'hidden'
    cellphone.name = 'cellphone'
    cellphone.value = this.cellphone
    form.appendChild(code)
    form.appendChild(cellphone)
    document.body.appendChild(form)
    form.submit()
  }
  orgLogin () {
    let form = document.createElement('form')
    form.action = config.COURSE_API_HOST + '/users/login/v2'
    form.method = 'post'
    let orgId = document.createElement("input")
    orgId.type = 'hidden'
    orgId.name = 'organId'
    orgId.value = this.orgId
    let loginName = document.createElement("input")
    loginName.type = 'hidden'
    loginName.name = 'loginName'
    loginName.value = this.loginName
    let password = document.createElement("input")
    password.type = 'hidden'
    password.name = 'password'
    password.value = this.password
    localStorage.setItem('ulearning-orgId', this.orgId)
    form.appendChild(orgId)
    form.appendChild(loginName)
    form.appendChild(password)
    document.body.appendChild(form)
    form.submit()
  }
  logoutCallback(params) {
    params = params || {}
    clearAllCookie()
    if (params.logoutToUrl) {
      location.href = params.logoutToUrl
    } else {
      location.reload()
    }
  }
  ///users/logout
  logout (params) {
    logout()
      .then(() => {
        this.logoutCallback(params)
      })
      .catch(err => {
        this.logoutCallback(params)
      })
  } 

  //切换到学生模式users/switchrole
  switchRole () {
    let mode = this.role == 8 ? 1 : 2
    cookies.set('isSwitch', mode)
    let form = document.createElement('form')
    form.action = config.COURSE_API_HOST + '/users/switchrole'
    form.method = 'post'
    let device = document.createElement("input")
    device.type = 'hidden'
    device.name = 'device'
    device.value = 2
    let authorization = document.createElement("input")
    authorization.type = 'hidden'
    authorization.name = 'Authorization'
    authorization.value = this.token
    let url = document.createElement('input')
    url.name = 'redirectUrl'
    url.value = location.href
    form.appendChild(device)
    form.appendChild(authorization)
    form.appendChild(url)
    document.body.appendChild(form)
    form.submit()
  }

  wxLogin (wxCode) {
    let form = document.createElement('form')
    form.action = config.COURSE_API_HOST + '/users/login/wechat'
    form.method = 'post'
    let code = document.createElement("input")
    code.type = 'hidden'
    code.name = 'code'
    code.value = wxCode
    form.appendChild(code)
    document.body.appendChild(form)
    form.submit()
  }
}
